import React, {useState} from 'react';
import {ScheduledTasksApi} from "api/ScheduledTasksApi";
import {downloadStringAsFile} from "utils/file-utils";
import {ScheduledTaskDTO} from "api/model/airflow-task/ScheduledTaskDTO";
import {easasErrorAlert} from "components/fragments/easas-global-fragment/EasasGlobalAlerts";
import {Dialog} from 'primereact/dialog';
import {Button} from 'primereact/button';
import {Calendar} from 'primereact/calendar';
import {DEFAULT_DATE_FORMAT} from "utils/constants";
import {DateTimeFormatter, Instant, ZoneId} from '@js-joda/core';

interface TaskDataDownloadDialogProps {
    visible: boolean;
    onClose: () => void;
    taskCfg: ScheduledTaskDTO;
}

export function TaskDataDownloadDialog(props: TaskDataDownloadDialogProps) {
    const [downloading, setDataDownloading] = useState(false);
    const [date, setDate] = useState(new Date());
    const [invalid, setInvalid] = useState(false);

    const handleDownloadData = () => {
        setDataDownloading(true);

        const instNow = Instant.ofEpochMilli(date.getTime());
        ScheduledTasksApi.getAirflowTaskJobData(
            props.taskCfg?.parentId!!,
            props.taskCfg?.id!!,
            instNow.toString()
        ).then((r) => {
            if (r.data) {
                // replace colons in date string to make it safe for file name and remove milliseconds
                const formatter = DateTimeFormatter.ofPattern("yyyy_MM_dd-HHmmss");
                const fileSafeDate = formatter.format(instNow.atZone(ZoneId.UTC));
                downloadStringAsFile(
                    JSON.stringify(r.data, null, 2),
                    `${props.taskCfg.parentId}:${props.taskCfg?.id}-${fileSafeDate}-taskdata.json`,
                    () => setDataDownloading(false)
                );
                props.onClose();
            } else {
                easasErrorAlert("Error downloading data or data empty");
            }

            setDataDownloading(false);
        });
    };

    const handleDateChange = (date: Date) => {
        if(isNaN(date.valueOf())) {
            setInvalid(true)
        } else {
            setDate(date);
            setInvalid(false)
        }
    }


    return <Dialog header="Download Task Data" visible={props.visible} onHide={props.onClose} style={{width: '300px'}}>
        <div className="p-fluid grid formgrid">
            <div className="p-field p-col-12">
                <span>
                    { !invalid && <span>Reference date</span>}
                    { invalid && <>
                        Invalid date
                        <i className="pi pi-exclamation-triangle ml-2" style={{color: "crimson"}}></i>
                    </>}
                </span>
                <Calendar showTime value={date}
                          dateFormat={DEFAULT_DATE_FORMAT}
                          hourFormat="24"
                          keepInvalid={true}
                          onChange={(e) => handleDateChange(e.value as Date)}></Calendar>
            </div>

            <div className="p-field p-col-12">
                <Button label="Download" icon="pi pi-download" className="p-button-success"
                        onClick={handleDownloadData} loading={downloading} disabled={invalid}/>
            </div>
        </div>
    </Dialog>


}